import ShareableLinksContentContainer from './ShareableLinksContentContainer.component';

export default ShareableLinksContentContainer;
